const notificationAudio = new Audio(
  require("../assets/sounds/universfield-new-notification-04-326127.mp3")
);

export const soundHelper = {
  playNotification: () => {
    notificationAudio.currentTime = 0;
    notificationAudio.play().catch(() => {});
  }
};
